import { TextBlock as TextBlockStyle } from './styles';

import type React from 'react';

type Props = JSX.IntrinsicElements['div'];

export const TextBlock: React.FC<Props> = ({ children }) => (
  <TextBlockStyle>{children}</TextBlockStyle>
);
